"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TwoColumnImageText() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    threshold: 0.3,
    rootMargin: "0px 0px -50px 0px"
  });
  return;
}